import * as React from 'react'
import autobind from 'autobind-decorator'
import {XYPlot, XAxis, YAxis, LineSeries, MarkSeries, Hint} from 'react-vis'
import DiscreteColorLegend from 'react-vis/dist/legends/discrete-color-legend'
import { WithStyles, Theme, createStyles, withStyles } from '@material-ui/core'
import { compose } from 'redux'
import { IChartConfig, IChartLegends } from 'src/type/chart'
import { withI18n } from 'src/core/i18n'
import { WithI18n } from 'src/core/i18n/withI18n'
import Alert from 'src/shared/Alert/Alert'
import { isString } from 'lodash'
import 'react-vis/dist/style.css'
import 'react-vis/dist/styles/legends.scss'

const styles = (t: Theme) => createStyles({
    root: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
        overflow: 'auto',
        [t.breakpoints.down('xs')]: {
          flexDirection: 'column'
        },
    },
    pointLegend: {
          padding: '9px 10px',
          display: 'flex',
          alignItems: 'center',
          fontSize: '12px'
    },
    point: {
        display: 'block',
        minWidth: '12px',
        width: '12px',
        height: '12px',
        marginRight: '17px',
        borderRadius: '50%'
    }
  })
  
  
  interface IProps extends WithI18n, WithStyles<typeof styles>{
    legend?: IChartLegends;
    vertical?: boolean;
    data: any;
    config: IChartConfig;
    condition?: boolean;
    isDefault?: boolean;
  }
  
  
  interface IState{
      size: number;
      points: any;
      selectedPointData: any;
      selectedPoint: any;
  }
  
  class Chart extends React.Component<IProps, IState> {
      state = {
          selectedPointData: undefined,
          selectedPoint: undefined,
          points: undefined,
          size: 500
      }
  
      render() {
          const {t, classes, config, legend, data, condition} = this.props
          const {size, selectedPoint, selectedPointData} = this.state
  
          return (
              <>
              {condition && 
                  <>
                      <div className={classes.root}>
                          {data && !isString(data) &&
                              <>
                                  {data && data.length > 0 && config && 
                                      <XYPlot 
                                          width={size} 
                                          height={size} 
                                      >
  
                                              <XAxis {...config.xAxis}/>
                                              <YAxis {...config.yAxis}/>
                                          
                                              {
                                                  data.map((l,i) => {
                                                      if(l.type === "line"){
                                                          return <LineSeries {...l} />
                                                      } else {
                                                          return <MarkSeries 
                                                                      {...l}
                                                                      onValueMouseOver={this.rememberValue}
                                                                      onValueMouseOut={this.forgetValue}
                                                                  />
                                                      }
                                                  })
                                              }
  
                                              {selectedPoint ? (
                                                  <Hint value={selectedPoint} >
                                                      <div className="rv-hint__content">{selectedPointData}</div>
                                                  </Hint>
                                              ) : null}
  
                                      </XYPlot>
                                  }
                                  {legend &&
                                      <div>
                                          <DiscreteColorLegend orientation="vertical"  items={legend.lines} />
                                          {this.legendPointsRender()}
                                      </div>
                                  }
                              </>
                          }
                      </div>
                      {data && isString(data) &&
                          <>
                              <Alert type="warning">Pas de graphique disponible pour ce scénario</Alert>
                              <br />
                              <Alert type="info">{data}</Alert>
                          </>
                      }
                  </>
              }
  
              {!condition &&
                  <Alert type="warning">{t.Cotation_chart_error}</Alert>
              }
              </>
          )
      }
  
      componentDidMount() {
          window.addEventListener("resize", this.resize);
          this.resize()
      }
  
      componentWillUnmount() {
          window.removeEventListener("resize", this.resize);
      }
  
      componentDidUpdate(prevProp){
          const {data} = this.props
          if(prevProp.data !== data && data && !isString(data)){
              const points = this.props.data.filter(d => d.type === 'point')
              if(points && points.length > 0){
                  this.setState({points});
              }
          }
      }
  
      @autobind
      private legendPointsRender(){
          const {classes, legend} = this.props
          if(legend && legend.points && legend.points.length > 0){
              return legend.points.map(p =>(
                  <div className={classes.pointLegend}>
                      <span className={classes.point} style={{backgroundColor: p.color}}></span>
                      <span>{p.title}</span>
                  </div>
              ))
          } else {
              return ""
          }
      }
  
      @autobind
      private forgetValue() {
          this.setState({
            selectedPoint: null
          });
      };
      
      @autobind
      private rememberValue(value){
          const {isDefault} = this.props;
          const pointObj = this.props.data.filter(d => d.type === 'point').find(obj => (obj.data[0].x === value.x && obj.data[0].y === value.y))
          const pointData = pointObj ? (isDefault === true ? this.captionRender(pointObj.caption) : pointObj.caption) : ""
          this.setState({selectedPoint: value, selectedPointData: pointData});
      };

      @autobind
      private captionRender(str: string){
          return str.slice(0, str.indexOf(":") - 1)
      }
  
      @autobind
      private resize(){
          if(window.innerWidth < 576){ this.setState({size: 300}) }
          if(window.innerWidth >= 576 && window.innerWidth < 768){ this.setState({size: 500}) }
          if(window.innerWidth >= 768){ this.setState({size: 500}) }
      }
  }
  
  export default compose(
      withI18n,
      withStyles(styles)
    )(Chart)
  


// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/Chart.tsx